<template>
    <div class="lucky-loser-wrapper">
        <div class="lucky-loser-notification">
            <i class="icon-lucky icon--md nav-sidebar-tree__icon icon-info_circle">

            </i>
            <div class="text">
                {{ $t('If you got any live events on the bet slip, your ticket is not eligible for either Lucky Loser or Super Bonus.')  }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LuckyLoserNotification"
}
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/shared/betSlip/LuckyLoserNotification.vue